export default {
  creditRequests: [],
  creditReports: [],
  total: 0,
  selected: [],
};
